import { render, staticRenderFns } from "./AdminSegmentCampaignsForm.vue?vue&type=template&id=4ffe2090&"
import script from "./AdminSegmentCampaignsForm.vue?vue&type=script&lang=js&"
export * from "./AdminSegmentCampaignsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports